<template>
    <Multiselect
        v-model="selected"
        placeholder="Select a status..."
        :options="options"
        track-by="id"
        label="label"
        selected-label=""
        :multiple="false"
        :loading="loading"
        @open="getStatuses"
    />
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {

    components: { Multiselect },

    props: {
        value: {
            type: Object,
            default: null,
        },
    },

    data() {
        return {
            loading: false,
            options: [],
        };
    },

    computed: {
        selected: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },

    methods: {
        async getStatuses() {
            this.loading = true;
            this.options = await this.$store.cache.dispatch('selects/getCostStatuses');
            this.loading = false;
        },
    },

};
</script>
